import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/lib/bookingDraftPrivacy";
import App from "@/App";
import { installBookingCatalogAdapter } from "@/lib/bookingCatalogAdapter";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
};

// The adapter installs its Axios guards synchronously before its first await,
// so the landing page does not need to wait for a booking-catalog network call.
// Its canonical fallback keeps the public device selector safe while the
// catalogue warms up in the background.
void installBookingCatalogAdapter();
renderApp();
